<template>
  <div>
    <div><h2>{{ $root.trans.elenco_sovrapposizioni}}</h2></div>
    <div v-if="sovrapposizioni.length > 0">
      <div v-for="(sovrapposizione, index) in sovrapposizioni" :key="index" class="mb-4 p-4 border border-red-300 rounded bg-red-50">
        <div class="mb-2">
          <span>{{ sovrapposizione.evento_principale.cliente }} - {{ sovrapposizione.evento_principale.cantiere }}</span>
          <span class="text-sm text-gray-600">
            ({{ sovrapposizione.evento_principale.dipendente }} -
            {{ formatoItalia(sovrapposizione.evento_principale.data_inizio) }}
            {{ sovrapposizione.evento_principale.ora_inizio.substring(0, 5) }})
          </span>
        </div>
        <div class="ml-4">
          <strong class="text-red-600">{{ $root.trans.sovrapposizione }}:</strong>
          <ul class="list-disc list-inside">
            <li v-for="(sovr, idx) in sovrapposizione.sovrapposizioni" :key="idx" class="text-sm">
              {{ sovr.cliente }} - {{ sovr.cantiere }}
              ({{ sovr.dipendente }} - {{ formatoItalia(sovr.data_inizio) }} {{ sovr.ora_inizio.substring(0, 5) }})
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
  <div>
    <Toast ref="toast" />
    <div>
      <h2>{{ $root.trans.cerca}}</h2>
    </div>
    <div>
      <label for="ora_fine" class="font-semibold block mb-1">{{ $root.trans.dipendente }}</label>
      <MultiSelect v-model="select_dipendenti" :options="dipendenti" filter optionLabel="nome"  optionValue="id" class="w-full" display="chip" />
    </div>
    <div>
      <label for="ora_fine" class="font-semibold block mb-1">{{ $root.trans.cliente }}</label>
      <MultiSelect v-model="select_contratti" :options="contratti" filter optionLabel="text"  optionValue="id" class="w-full" display="chip" />
    </div>
    <div>
      <label for="ora_fine" class="font-semibold block mb-1">{{ $root.trans.automezzi }}</label>
      <MultiSelect v-model="select_automezzi" :options="automezzi" filter optionLabel="nome"  optionValue="id" class="w-full" display="chip" />
    </div>
    <div>
      <label for="ora_fine" class="font-semibold block mb-1">{{ $root.trans.visualizzazione }}</label>
      <Select v-model="select_visualizzazione" :options="visualizza" :name="nome" optionLabel="nome" optionValue="id" />
    </div>
    <div class="flex gap-2 items-end">
      <Button fluid severity="success" text size="small" icon="pi pi-search" @click="filtraCalendario()"/>
      <Button v-if="filtriAttivi" severity="secondary" text size="small" icon="pi pi-times" @click="pulisciFiltri()" />
    </div>
  </div>
  <div>
    <FullCalendar ref="fullCalendar" :options="calendarOptions"/>
  </div>
  <Drawer v-model:visible="showDrawer" position="right">
    <p v-if="dettaglioEventoData.sovrapposizione ==1">{{ $root.trans.sovrapposizione }}</p>
    <p>{{ $root.trans.dettaglio_appuntamento }}</p>
    <div>
      <p><strong>{{ $root.trans.cliente }}:</strong> {{ dettaglioEventoData.cliente }}</p>
      <p><strong>{{ $root.trans.cantiere }}:</strong> {{ dettaglioEventoData.cantiere }}</p>
      <p><strong>{{ $root.trans.servizio }}:</strong> {{ dettaglioEventoData.servizio }}</p>
      <p><strong>{{ $root.trans.dal }}:</strong> {{ dettaglioEventoData.ora_inizio }} </p>
      <p><strong>{{ $root.trans.al }}:</strong> {{ dettaglioEventoData.ora_fine }}</p>
      <p>
        <strong>{{ $root.trans.automezzi }}:</strong> {{ dettaglioEventoData.automezzo }} <Button
        v-if="dettaglioEventoData.automezzo != ''"
        icon="pi pi-trash"
        class="p-button-danger p-button-sm"
        :label="$root.trans.elimina_macchina"
        @click="eliminaMacchina(dettaglioEventoData.planner_id)"
      /></p>
      <h3>{{ $root.trans.dipendenti }}</h3>
      <ul>
        <li v-for="dip in dettaglioEventoData.dipendenti" :key="dip.id">
          {{ dip.text }}
          <Button icon="pi pi-exchange" class="p-button-warning p-button-sm" @click="sostituisciDipendente(dip.id)"/>
          <Button icon="pi pi-trash" class="p-button-danger p-button-sm" @click="rimuoviDipendente(dip.id, dip.text)"/>
        </li>
      </ul>
      <div class="field">
        <label>{{ $root.trans.note }}:</label>
        <Editor
          v-model="dettaglioEventoData.note"
          :readonly="true"
          :toolbar="false"
          editorStyle="min-height: 100px; border: 1px solid #d1d5db; background-color: #f9fafb;"
        />
      </div>
      <div class="mt-4 flex gap-2">
        <Button
          icon="pi pi-user-plus"
          class="p-button-success"
          :label="$root.trans.aggiungi_dipendente"
          @click="aggiungiDipendente(dettaglioEventoData.planner_id)"
        />
        <Button
          icon="pi pi-car"
          class="p-button-info"
          :label="$root.trans.gestisci_macchina"
          @click="gestisciMacchina(dettaglioEventoData.planner_id)"
        />
        <Button
          icon="pi pi-trash"
          class="p-button-danger"
          :label="$root.trans.elimina_evento"
          @click="eliminaEvento(dettaglioEventoData.planner_id)"
        />
      </div>

    </div>
  </Drawer>

  <!-- Sostituzione Dipendente -->
  <Dialog v-model:visible="showDipendenteReplace" :header="$root.trans.sostituisci_dipendente" :modal="true">
    <label for="ora_fine" class="font-semibold block mb-1">{{ $root.trans.sostituisci_con }}</label>
    <MultiSelect v-model="dipendenteSostituto" :options="dipendenti" filter optionLabel="text" optionValue="id" class="w-full"/>
    <div class="my-3">
      <div>
        <RadioButton v-model="tipoSostituzione" :inputId="'sostituzioneParziale'" name="tipoSostituzione" :value="1"/>
        <label for="sostituzioneParziale" class="ml-2">{{ $root.trans.sostituzione_parziale }}</label>
      </div>
      <div>
        <RadioButton v-model="tipoSostituzione" :inputId="'sostituzioneTotale'" name="tipoSostituzione" :value="2"/>
        <label for="sostituzioneTotale" class="ml-2">{{ $root.trans.sostituzione_totale }}</label>
      </div>
      <div>
        <RadioButton v-model="tipoSostituzione" :inputId="'sostituzioneCompleta'" name="tipoSostituzione" :value="3"/>
        <label for="sostituzioneCompleta" class="ml-2">{{ $root.trans.sostituzione_completa }}</label>
      </div>
    </div>
    <!-- Date solo se selezionata la sostituzione totale -->
    <div v-if="tipoSostituzione == 2" class="p-field-checkbox">
      <label for="data_inizio" class="font-semibold block mb-1">{{ $root.trans.dal }}</label>
      <DatePicker v-model="sostituzione_data_inizio" id="data_inizio" showIcon fluid :showOnFocus="false" dateFormat="dd-mm-yy" class="w-full" />
      <label for="data_fine" class="font-semibold block mb-1">{{ $root.trans.al }}</label>
      <DatePicker v-model="sostituzione_data_fine" id="data_fine" showIcon fluid :showOnFocus="false" dateFormat="dd-mm-yy" class="w-full" />
    </div>

    <Button :label="$root.trans.conferma_sostituzione" class="p-button-warning" @click="confermaSostituzione"/>
  </Dialog>

  <!-- Elimina Dipendente -->
  <Dialog v-model:visible="showDipendenteElimina" :header="$root.trans.planner_elimina_dipendente+ ' ' + dipendenteSelezionato" :modal="true">
    <div class="my-3">
      <div>
        <RadioButton v-model="tipoSostituzione" :inputId="'sostituzioneParziale'" name="tipoSostituzione" :value="1"/>
        <label for="sostituzioneParziale" class="ml-2">{{ $root.trans.planner_elimina_singolo_evento }}</label>
      </div>
      <div>
        <RadioButton v-model="tipoSostituzione" :inputId="'sostituzioneTotale'" name="tipoSostituzione" :value="2"/>
        <label for="sostituzioneTotale" class="ml-2">{{ $root.trans.planner_elimina_eventi_gs }}</label>
      </div>
      <div>
        <RadioButton v-model="tipoSostituzione" :inputId="'sostituzioneCompleta'" name="tipoSostituzione" :value="3"/>
        <label for="sostituzioneCompleta" class="ml-2">{{ $root.trans.planner_elimina_tutti_eventi }}</label>
      </div>
    </div>
    <Button :label="$root.trans.conferma_eliminazione" class="p-button-warning" @click="confermaEliminazione"/>
  </Dialog>

  <!-- Gestisci macchina -->
  <Dialog v-model:visible="showMacchinaEdit" :header="$root.trans.scegli_automezzo" :modal="true">
    <Select v-model="nuovoAutomezzo" :options="automezzi" optionLabel="nome" optionValue="id" class="w-full" filter />
    <div class="my-3">
      <div>
        <RadioButton v-model="tipoSostituzione" :inputId="'sostituzioneParziale'" name="tipoSostituzione" :value="1"/>
        <label for="sostituzioneParziale" class="ml-2">{{ $root.trans.planner_aggiungieliminamacchina_singolo_evento }}</label>
      </div>
      <div>
        <RadioButton v-model="tipoSostituzione" :inputId="'sostituzioneTotale'" name="tipoSostituzione" :value="2"/>
        <label for="sostituzioneTotale" class="ml-2">{{ $root.trans.planner_aggiungieliminamacchina_eventi_gs }}</label>
      </div>
    </div>
    <Button :label="$root.trans.salva" class="p-button-success" @click="modificaMacchina"/>
  </Dialog>

  <!-- Aggiungi dipendente -->
  <Dialog v-model:visible="showDipendenteAdd" :header="$root.trans.planner_aggiungi_dipendente" :modal="true">
    <MultiSelect v-model="nuovoDipendente" :options="dipendenti" filter optionLabel="text" optionValue="id" class="w-full" display="chip" />
    <Button :label="$root.trans.salva" class="p-button-success" @click="salvaDipendente"/>
  </Dialog>

  <!-- Nuovo evento -->
  <Dialog v-model:visible="showNuovoEvento" :header="$root.trans.planner_crea_evento" :modal="true">
    <div>
      <label for="clientiSelezionati" class="font-semibold block mb-1">{{ $root.trans.cliente }}</label>
      <Select v-model="selectCliente" :options="contratti" filter optionLabel="text"  optionValue="id" class="w-full" display="chip" @change="onClienteChange" />
    </div>
    <div>
      <label for="clientiSelezionati" class="font-semibold block mb-1">{{ $root.trans.servizi }}</label>
      <Select v-model="selectServizi" :options="servizio" filter optionLabel="text"  optionValue="id" class="w-full" display="chip" :disabled="serviziSelect" />
    </div>
    <div>
    <label for="data_inizio" class="font-semibold block mb-1">{{ $root.trans.data_di_inizio }} *</label>
    <DatePicker v-model="nuovo_data_inizio" id="data_inizio" showIcon fluid :showOnFocus="true" dateFormat="dd-mm-yy" class="w-full" />
    </div>

    <div>
      <label for="data_fine" class="font-semibold block mb-1">{{ $root.trans.data_fine }} *</label>
      <DatePicker v-model="nuovo_data_fine" id="data_fine" showIcon fluid :showOnFocus="true" dateFormat="dd-mm-yy" class="w-full" />
    </div>
    <div>
      <label for="ora_inizio" class="font-semibold block mb-1">{{ $root.trans.ora_inizio }} *</label>
      <DatePicker v-model="nuovo_ora_inizio" id="ora_inizio" timeOnly showIcon fluid :showOnFocus="true" dateFormat="hh:mm" :disabled="fasciaOrariaSelezionata > 0" class="w-full" />
    </div>

    <div>
      <label for="ora_fine" class="font-semibold block mb-1">{{ $root.trans.ora_fine }} *</label>
      <DatePicker v-model="nuovo_ora_fine" id="ora_fine" timeOnly showIcon fluid :showOnFocus="true" dateFormat="hh:mm" :disabled="fasciaOrariaSelezionata > 0" class="w-full" />
    </div>
    <div>
      <label for="dipendentiSelezionati" class="font-semibold block mb-1">{{ $root.trans.dipendenti }} *</label>
      <MultiSelect v-model="nuovoDipendente" :options="dipendenti" filter optionLabel="text" optionValue="id" class="w-full" display="chip" />
    </div>

    <div>
      <label for="automezzoSelezionato" class="font-semibold block mb-1">{{ $root.trans.automezzi }}</label>
      <Select v-model="automezzoSelezionato" id="automezzoSelezionato" :options="automezzi" optionLabel="nome" optionValue="id" class="w-full" filter />
    </div>
    <div class="col-span-3">
      <label for="note" class="font-semibold block mb-1">{{ $root.trans.note }}</label>
      <Editor v-model="note" id="note" editorStyle="height: 200px" class="w-full" />
    </div>
    <Button :label="$root.trans.salva" class="p-button-success" @click="salvaEvento"/>
  </Dialog>

</template>

<script>
import axios from 'axios';
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import Dialog from 'primevue/dialog';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import DatePicker from 'primevue/datepicker';
import Toast from 'primevue/toast';
import Drawer from 'primevue/drawer';
import RadioButton from 'primevue/radiobutton';
import Editor from 'primevue/editor';

export default {
  name: "CalendarioComponent",
  props: ["visualizzazione","dipendenti","automezzi","rotta_eventi","rotta_spostamento","rotta_eventi_elimina","rotta_dettaglio","contratti"],
  components: {
    FullCalendar,
    Dialog,
    Select,
    MultiSelect,
    Button,
    Checkbox,
    DatePicker,
    Toast,
    Drawer,
    RadioButton,
    Editor
  },
  data() {
    return {
      sovrapposizioni: [],
      filtriAttivi: false,
      eventiOriginali: [],
      showDrawer: false,
      showModalDettaglio: false,
      showDipendenteElimina:false,
      showNuovoEvento: false,
      tipoSostituzione: 1,
      select_automezzi: [],
      select_dipendenti: [],
      select_contratti: [],
      select_visualizzazione: this.visualizzazione,
      visualizza: [{nome: 'Per cantiere', id:1},{nome: 'Per dipendente', id:2}],
      sostituzione_data_inizio: null,
      sostituzione_data_fine: null,
      nuovo_data_inizio: null,
      nuovo_data_fine: null,
      nuovo_ora_inizio: null,
      nuovo_ora_fine: null,
      serviziSelect: true,
      selectServizi: [],
      servizio: [],
      selectCliente:null,
      csrfToken: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
      dettaglioEventoData: {
        cliente: '',
        automezzo: '',
        ora_inizio: '',
        ora_fine: '',
        dipendenti: []
      },
      showDipendenteAdd: false,
      showMacchinaEdit: false,
      showDipendenteReplace: false,
      nuovoDipendente: [],
      nuovoAutomezzo: null,
      dipendenteSostituto: null,
      applicaATutti: false,
      calendarOptions: {
        headerToolbar: {
          left: 'prev next today',
          center: 'title',
          right: 'dayGridMonth timeGridWeek timeGridDay'
        },
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'timeGridWeek',
        slotDuration: '00:30',
        allDaySlot: false,
        locale: 'it',
        firstDay: 1,
        eventSources: [
          {
            url: route(this.rotta_eventi),
            method: 'GET',
            failure: function () {
              alert(window.trans('errore_caricamento_dati'));
            },
            color: 'yellow',   // a non-ajax option
            textColor: 'black' // a non-ajax option
          }
        ],
        editable: true,
        dateClick: this.creaNuovoEvento,
        eventClick: this.dettaglioEvento,
        eventResize: (info) => {
          //cambio solo ora di fine
          if (!confirm(window.trans('vuoi_salvare'))) {
            info.revert();
          } else {
            //salva
            axios.post(route(this.rotta_spostamento), {
              id: info.event.id,
              inizio: info.event.start,
              fine: info.event.end,
            }).then((response) => {
              this.$refs.toast.add({
                severity: 'success',
                summary: this.$root.trans.success_form,
                detail: this.$root.trans.salvataggio_success,
                life: 3000
              });
            }).catch(() => {
              this.$refs.toast.add({
                severity: 'error',
                summary: this.$root.trans.errore,
                detail: this.$root.trans.errore_generico,
                life: 3000
              });
              info.revert(); // fallback in caso di errore
            });
          }
        },
        droppable: true,
        viewDidMount: this.onCalendarViewChange,
        datesSet: this.onCalendarViewChange,
        eventDrop: (info) => {
          if (!confirm(window.trans('vuoi_salvare'))) {
            info.revert();
          } else {
            var nuova_data = new Date(info.event.start);
            var oggi = new Date();
            if (oggi < nuova_data) {
              axios.post(route(this.rotta_spostamento), {
                id: info.event.id,
                inizio: info.event.start,
                fine: info.event.end,
              }).then((response) => {
                this.$refs.toast.add({
                  severity: 'success',
                  summary: this.$root.trans.success_form,
                  detail: this.$root.trans.salvataggio_success,
                  life: 3000
                });
              }).catch(() => {
                this.$refs.toast.add({
                  severity: 'error',
                  summary: this.$root.trans.errore,
                  detail: this.$root.trans.errore_generico,
                  life: 3000
                });
                info.revert(); // fallback in caso di errore
              });
            } else {
              alert(window.trans('planner_sposta_errore'));
              info.revert();
            }
          }
        }
      }
    }
  },

  methods: {
    dettaglioEvento: function (arg) {
      this.showDrawer = true;
      var info = arg.event;
      var id = info.id;
      var titolo = info.title;
      var tabella = info.extendedProps.tabella;
      var rotta = this.rotta_dettaglio.find(r => r.tabella === tabella);
      var vm = this;
      if (rotta) {
        axios.post(route(rotta.rotta), {
          id: id,
          tabella: tabella
        }).then(function (response) {
          vm.dettaglioEventoData = response.data;
        });
      }
    },
    rimuoviDipendente(id, testo) {
      var data_appuntamento = this.dettaglioEventoData.ora_inizio;
      const ieri = new Date();
      ieri.setHours(0, 0, 0, 0);
      ieri.setDate(ieri.getDate() - 1);
      const evento = new Date(data_appuntamento);
      evento.setHours(0, 0, 0, 0);
      if (evento <= ieri) {
        this.showDipendenteElimina = false;
      } else {
        this.showDipendenteElimina = true;
        this.dipendenteSelezionato = testo;
        this.dipendenteDaEliminare = id;
      }
    },
    confermaEliminazione() {
      var scelta = this.tipoSostituzione;
      var id = this.dipendenteDaEliminare;
      axios.post(route('planner/calendario/eventi/dettaglio/rimuovi_dipendente'), {
        id: this.dettaglioEventoData.planner_id,
        dipendente_id: this.dipendenteDaEliminare,
        tipo: scelta
      }).then(() => {
        this.dettaglioEventoData.dipendenti = this.dettaglioEventoData.dipendenti.filter(d => d.id !== id);
        this.showDipendenteElimina = false;
      }).catch(error => console.error('Errore rimozione dipendente:', error));
    },
    sostituisciDipendente(id) {
      this.dipendenteSostituto = null;
      this.applicaATutti = false;
      this.showDipendenteReplace = true;
      this.dipendenteDaSostituire = id;
    },
    createDateFromString(dateString) {
      // Dividi la stringa in giorno, mese e anno
      if (typeof dateString === 'string') {
        const [day, month, year] = dateString.split('-').map(Number);
        // Crea un oggetto Date (il mese è 0-based, quindi sottrai 1)
        return new Date(year, month - 1, day);
      } else {
        return dateString;
      }
    },
    confermaSostituzione() {
      var err = 0;
      if (this.tipoSostituzione == 2) {
        if (this.sostituzione_data_inizio == null || this.sostituzione_data_fine == null) {
          err++;
          alert(window.trans('planner_inserire_date'))
        } else {
          const inizio = this.createDateFromString(this.sostituzione_data_inizio);
          const fine = this.createDateFromString(this.sostituzione_data_fine);

          if (inizio >= fine) {
            err++;
            alert(window.trans('planner_inserire_date'));
          }

        }
      }
      if (!this.dipendenteSostituto || this.dipendenteSostituto.length === 0) {
        err++;
        alert(window.trans('planner_inserire_dipendente'));
      }
      if (err == 0) {
        axios.post(route('planner/calendario/eventi/dettaglio/sostituisci_dipendente'), {
          id: this.dettaglioEventoData.planner_id,
          dipendente_da_sostituire: this.dipendenteDaSostituire,
          nuovo_dipendente: this.dipendenteSostituto,
          tipo_sostituzione: this.tipoSostituzione,
          sostituzione_data_inizio: this.sostituzione_data_inizio,
          sostituzione_data_fine: this.sostituzione_data_fine
        }).then(response => {
          this.dettaglioEventoData.dipendenti = response.data.dipendenti;
          this.showDipendenteReplace = false;
        }).catch(error => console.error('Errore sostituzione dipendente:', error));
      }
    },
    gestisciMacchina(planner_id) {
      this.showMacchinaEdit = true;
      //this.nuovoAutomezzo = this.dettaglioEventoData.automezzo_id;
    },
    eliminaMacchina(planner_id) {
      if (confirm(window.trans('planner_uoi_eliminare_macchina'))) {
        axios.post(route('planner/calendario/eventi/dettaglio/elimina_macchina'), {
          id: planner_id,
        }).then(response => {
          this.dettaglioEventoData.automezzo = response.data.automezzo;
          this.showMacchinaEdit = false;
        }).catch(error => console.error('Errore modifica macchina:', error));
      }
    },
    modificaMacchina() {
      console.log(this.dettaglioEventoData.planner_id);
      axios.post(route('planner/calendario/eventi/dettaglio/modifica_macchina'), {
        id: this.dettaglioEventoData.planner_id,
        nuovo_automezzo: this.nuovoAutomezzo,
        tipo_sostituzione: this.tipoSostituzione
      }).then(response => {
        this.dettaglioEventoData.automezzo = response.data.automezzo;
        this.showMacchinaEdit = false;
      }).catch(error => console.error('Errore modifica macchina:', error));
    },
    creaNuovoEvento: function (arg) {
      const cella = new Date(arg.date);
      this.nuovo_data_inizio = cella;
      this.nuovo_data_fine = cella;
      this.nuovo_ora_inizio = cella;
      var ora_fine_date = new Date(cella);
      ora_fine_date.setHours(ora_fine_date.getHours() + 1);
      this.nuovo_ora_fine = ora_fine_date;
      this.showNuovoEvento = true;
    },
    eliminaEvento(id) {
      console.log(this.calendarOptions);
      if (confirm(window.trans('planner_uoi_eliminare_questo_evento'))) {
        axios.post(route('planner/calendario/eventi/dettaglio/elimina_evento_singolo'), {
          id: id,
        }).then(response => {
          this.showDrawer = false;
          const calendarApi = this.$refs.fullCalendar.getApi();
          const event = calendarApi.getEventById(id);
          if (event) {
            event.remove();
          }
        }).catch(error => console.error('Errore modifica evento:', error));
      }
    },
    aggiungiDipendente(planner_id) {
      this.showDipendenteAdd = true;
      //this.nuovoAutomezzo = this.dettaglioEventoData.automezzo_id;
    },
    salvaDipendente() {
      axios.post(route('planner/calendario/eventi/dettaglio/aggiungi_dipendente'), {
        id: this.dettaglioEventoData.planner_id,
        dipendenti: this.nuovoDipendente,
      }).then(response => {
        console.log(response);
        this.showDipendenteAdd = false;
        this.dettaglioEventoData.dipendenti = response.data;
      }).catch(error => console.error('Errore aggiunta dipendente:', error));
    },
    onClienteChange() {
      this.selectServizi = null;
      axios.post(route('clienti/cantieri/contratti/servizi/elenco'), {
        id: this.selectCliente
      }).then(response => {
        const dati = response.data;
        this.servizio = dati.map(item => ({
          text: item.servizio,
          id: item.contratti_servizi_id
        }));
        this.serviziSelect = this.servizio.length === 0;
      }).catch(error => console.error('Errore caricamento servizio:', error));
    },
    async salvaEvento() {
      if (
        !this.selectCliente ||
        !this.nuovo_data_inizio ||
        !this.nuovo_data_fine ||
        !this.nuovo_ora_inizio ||
        !this.nuovo_ora_fine ||
        !this.nuovoDipendente ||
        this.nuovoDipendente.length === 0
      ) {
        this.$refs.toast.add({ severity: 'error', summary: this.$root.trans.errors_form, detail: this.$root.trans.compila_campi_obbligatori });
        return;
      }
      const dataInizioFormatted = this.formatDate(this.nuovo_data_inizio);
      const dataFineFormatted = this.formatDate(this.nuovo_data_fine);
      const oraInizioFormatted = this.formatTime(this.nuovo_ora_inizio);
      const oraFineFormatted = this.formatTime(this.nuovo_ora_fine);

      axios.post(route('planner/calendario/eventi/salva'), {
        cliente: this.selectCliente,
        servizi: this.selectServizi || 0,
        data_inizio: this.nuovo_data_inizio,
        data_fine: this.nuovo_data_fine,
        ora_inizio: this.nuovo_ora_inizio,
        ora_fine: this.nuovo_ora_fine,
        dipendenti: this.nuovoDipendente,
        automezzo: this.automezzoSelezionato || 0,
        note: this.note || ''
      }).then(response => {
        this.showNuovoEvento = false;
        this.pulisciCampiNuovoEvento();
        if (Array.isArray(response.data)) {
          // Se è un array, aggiungi tutti gli eventi al calendario
          response.data.forEach(evento => {
            console.log('Aggiungendo evento:', evento);
            this.$refs.fullCalendar.getApi().addEvent(evento);
          });
        } else {
          // Se è un singolo oggetto
          console.log('Aggiungendo evento singolo:', response.data);
          this.$refs.fullCalendar.getApi().addEvent(response.data);
        }

      }).catch(error => console.error('Errore aggiunta evento:', error));
    },
    formatoItalia(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('it-IT');
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatTime(time) {
      if (!time) return '';
      const t = new Date(time);
      const hours = String(t.getHours()).padStart(2, '0');
      const minutes = String(t.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    },
    pulisciCampiNuovoEvento() {
      this.selectCliente = null;
      this.selectServizi = null;
      this.nuovo_data_inizio = null;
      this.nuovo_data_fine = null;
      this.nuovo_ora_inizio = null;
      this.nuovo_ora_fine = null;
      this.nuovoDipendente = [];
      this.automezzoSelezionato = null;
      this.note = '';
      this.servizio = [];
      this.serviziSelect = true;
    },
    async caricaSovrapposizioni() {
      try {
        const view = this.$refs.fullCalendar.getApi().view;
        const start = view.activeStart.toISOString().split('T')[0];
        const end = view.activeEnd.toISOString().split('T')[0];

        const response = await axios.get(route('planner/calendario/sovrapposizioni'), {
          params: {
            data_inizio: start,
            data_fine: end,
            dipendenti: this.select_dipendenti.join(',') || null,
            contratti: this.select_contratti.join(',') || null,
            automezzi: this.select_automezzi.join(',') || null
          }
        });

        this.sovrapposizioni = response.data;
      } catch (error) {
        console.error('Errore nel caricamento delle sovrapposizioni:', error);
      }
    },
    filtraCalendario() {
      if (!this.filtriAttivi) {
        this.eventiOriginali = this.$refs.fullCalendar.getApi().getEvents().map(event => ({
          id: event.id,
          title: event.title,
          start: event.start,
          end: event.end,
          color: event.color,
          extendedProps: event.extendedProps
        }));
      }
      this.applicaFiltri();
      this.caricaSovrapposizioni();
      this.filtriAttivi = true;
    },
    applicaFiltri() {
      const api = this.$refs.fullCalendar.getApi();
      const tuttiEventi = api.getEvents();
      tuttiEventi.forEach(event => event.remove());
      const filtri = {
        dipendenti: this.select_dipendenti || [],
        contratti: this.select_contratti || [],
        automezzi: this.select_automezzi || [],
        visualizzazione: this.select_visualizzazione || null
      };
      const view = api.view;
      const start = view.activeStart.toISOString().split('T')[0];
      const end = view.activeEnd.toISOString().split('T')[0];
      console.log(this.select_visualizzazione);
      axios.get(route('planner/calendario/eventi'), {
        params: {
          start: start,
          end: end,
          dipendenti: this.select_dipendenti.join(',') || 0,
          contratti: this.select_contratti.join(',') || 0,
          automezzi: this.select_automezzi.join(',') || 0,
          visualizzazione: this.select_visualizzazione
        }
      }).then(response => {
        console.log(response.data);
        response.data.forEach(evento => {
          console.log('Aggiungendo evento:', evento);
          this.$refs.fullCalendar.getApi().addEvent(evento);
        });
      }).catch(error => {
        console.error('Errore nel caricamento eventi filtrati:', error);
      });
    },
    onCalendarViewChange() {
      this.caricaSovrapposizioni();
    },
    pulisciFiltri() {

      // Reset delle selezioni
      this.select_dipendenti = [];
      this.select_contratti = [];
      this.select_automezzi = [];
      this.select_visualizzazione = null;

      // Se i filtri erano attivi, ripristina gli eventi originali
      if (this.filtriAttivi) {
        const api = this.$refs.fullCalendar.getApi();

        // Rimuovi tutti gli eventi attuali
        const tuttiEventi = api.getEvents();
        tuttiEventi.forEach(event => event.remove());

        // Ripristina gli eventi originali
        this.eventiOriginali.forEach(evento => {
          api.addEvent(evento);
        });

        // Reset dello stato
        this.filtriAttivi = false;
        this.eventiOriginali = [];
      }
    },

    // Aggiorna il metodo esistente per gestire i filtri
    fetchEvents(info, successCallback, failureCallback) {
      const params = {
        start: info.startStr,
        end: info.endStr
      };

      // Se i filtri sono attivi, non ricaricare automaticamente
      if (this.filtriAttivi) {
        successCallback([]);
        return;
      }

      axios.get(route('planner/calendario/eventi'), { params })
        .then(response => {
          successCallback(response.data);
        })
        .catch(error => {
          console.error('Errore nel caricamento degli eventi:', error);
          failureCallback(error);
        });
    }

  },
  mounted() {
    this.$nextTick(() => {
      this.caricaSovrapposizioni();
    });
  }
}
</script>

<style scoped>

</style>